import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { getactionMessages } from '../../constants/messages';
import AddRequestModal from './AddRequestModal';

let messages = getactionMessages();

const AddRequestButton = () => {
	const [openModal, setOpenModal] = useState(false);

	return (
		<React.Fragment>
			<Button
				className="editable-add-btn"
				type="primary"
				onClick={() => setOpenModal(true)}
				icon={<PlusOutlined />}
			>
				<FormattedMessage {...messages.add} />
			</Button>
			<AddRequestModal visible={openModal} handleCancel={() => setOpenModal(false)} />
		</React.Fragment>
	);
};

export default AddRequestButton;
